import React, { useState } from "react";
import { Container, Button } from 'reactstrap';

import moment  from 'moment';
import Cookies from 'js-cookie';

import useResize           from "~/hooks/useResize";
import NotificationBellImg from "~/assets/images/notification-bell.png";
import User                from "~/services/user";

const PushNotificationQuestion = ({setOverlayOpen, setExpandedHeader, breakpoint})=> {

  const [disabled, setDisabled] = useState(false);
  const [ width ]               = useResize();

  const showNotificationPermission = async ()=> {

    setDisabled(true);
    let sw = await navigator.serviceWorker.ready;
    let push = (await sw.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: process.env.REACT_APP_VAPID_PUBLIC_KEY
    }).catch(onClose)).toJSON();

    User.registerPushSubscription({
      endpoint  : push.endpoint,
      authKey   : push.keys.auth,
      publicKey : push.keys.p256dh,
    }).finally(onClose);
  }

  const onClose = ()=> {
    let expiration = moment().add(24, "hours").toDate();
    Cookies.set('PushNotificaionQuestion', true, {expires: expiration});
    setDisabled(false);

    setExpandedHeader(width < breakpoint);
    setOverlayOpen(false);
  };


  return (
    <Container className="push-notification-question-modal">
      <img src={NotificationBellImg} style={{width: 200}} className="text-center" />
      <h5>  Click to subscribe to push notifications and win 50 points!</h5>
      <button className="btn action btn-primary" onClick={showNotificationPermission} disabled={disabled}>
       { !disabled && <span> Click to subscribe  </span> }
       {  disabled && <span> Allow notifications </span> }
      </button>
      <Button className="close-x" color="dark" onClick={onClose}> &times; </Button>
    </Container>
  );
};

export default PushNotificationQuestion;
